import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b8b643a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "mf-login",
  class: "tw bg-white"
}
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "inline-block w-full max-w-[400px] text-left align-top" }
const _hoisted_4 = { class: "ocm-headline2 mb-6 flex items-center" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "ocm-body1 mb-4" }
const _hoisted_7 = {
  key: 0,
  class: "social-login mb-6"
}
const _hoisted_8 = { class: "line-on-side mb-4 text-center text-base leading-5 text-gray-80" }
const _hoisted_9 = { class: "mb-6 flex items-center justify-center" }
const _hoisted_10 = { class: "line-on-side text-center text-base leading-5 text-gray-80" }
const _hoisted_11 = { class: "mb-4 flex flex-col gap-4 text-sm" }
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]
const _hoisted_14 = { class: "font-normal" }
const _hoisted_15 = { class: "underline" }

import { VueRecaptcha } from "vue-recaptcha";
import SharedButton from "@SharedVueComponents/SharedButton.vue";
import SharedForm from "@SharedVueComponents/SharedForm/SharedForm.vue";
import SvgIcon from "@SharedVueComponents/SvgIcon/SvgIcon.vue";
import SharedTextfield from "@SharedVueComponents/SharedTextfield.vue";
import { passwordValidator } from "@/services/validation";
import GlobalError from "@/components/GlobalError.vue";
import AppleLogin from "@/components/SocialLogins/AppleLogin.vue";
import GoogleLogin from "@/components/SocialLogins/GoogleLogin.vue";
import FacebookLogin from "@/components/SocialLogins/FacebookLogin.vue";
import { contextPath, country } from "@ocm/services/ocm-object";

import { pushEvent } from "./services/dataLayerLogin";
import { computed, onMounted, ref } from "vue";
import CaptchaText from "./components/CaptchaText.vue";
import { store } from "./state/store";
import { authenticate } from "@/services/ocmAuthentication";

const section = "reauth";

export default /*#__PURE__*/_defineComponent({
  __name: 'ReAuth',
  setup(__props) {

const invisibleReCaptcha = ref<VueRecaptcha | null>(null);

const hasCaptcha = !!window.ocm?.captchaOptions?.publickey;
const password = ref("");

const captcha = ref({
	response: null,
	key: window.ocm?.captchaOptions?.publickey,
	loaded: false,
});
const isSubmitLoading = ref(false);
const appleReAuthAllowed = window.ocm.reAuthPageOptions.appleReAuthAllowed;
const googleReAuthAllowed = window.ocm.reAuthPageOptions.googleReAuthAllowed;
const facebookReAuthAllowed = window.ocm.reAuthPageOptions.facebookReAuthAllowed;
const registrationOrigin = window.ocm.reAuthPageOptions.registrationOrigin;

onMounted(() => {
	store.isReauth = true;

	if (captcha.value.key) {
		let intervalCount = 0;
		const intervalID = window.setInterval(() => {
			if (intervalCount++ > 150) window.clearInterval(intervalID);
			if (typeof grecaptcha === "undefined") return;
			captcha.value.loaded = true;
			window.clearInterval(intervalID);
		}, 200);
	}
});

function sendTracking(event: MouseEvent) {
	const trackedElement = (event?.currentTarget as HTMLElement)?.dataset?.trackElement;
	if (trackedElement) pushEvent(trackedElement);
}

function handleSubmitClick() {
	if (captcha.value.key) {
		invisibleReCaptcha.value?.execute();
		return;
	}
	submitForm();
}
async function submitForm() {
	isSubmitLoading.value = true;

	const authData = {
		j_username: store.username,
		j_password: password.value,
		"g-recaptcha-response": captcha.value.response || "",
	};

	const success = await authenticate(authData, section);
	if (!success) isSubmitLoading.value = false;
}

function handleOnInput() {
	resetGlobalError();
}

function resetGlobalError() {
	store.globalErrorMessages = [];
	store.httpErrorStatusCode = null;
}

function handleCaptchaResponse(response: any) {
	captcha.value.response = response;
	invisibleReCaptcha.value?.reset();
	submitForm();
}

const maskedUsername = computed(() => {
	if (!store.username.includes("@")) {
		return store.username;
	}
	const [usernameBeforeAt, domain] = store.username.split("@");
	if (usernameBeforeAt.length <= 3) {
		return store.username;
	}

	const firstThreeChars = usernameBeforeAt.substring(0, 3);
	const maskedUsername = firstThreeChars.padEnd(usernameBeforeAt.length, "•");
	return `${maskedUsername}@${domain}`;
});

function passwortForgottenLink() {
	return `${window.location.origin}${contextPath}/my-account/forgotten-password`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, [
          _createVNode(SvgIcon, {
            "icon-name": "user-privacy",
            class: "mr-2 h-15 w-15"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.$t("reauth.headline")), 1)
        ]),
        _createElementVNode("p", {
          class: "ocm-body1 mb-4",
          innerHTML: _ctx.$t('reauth.formText', [maskedUsername.value])
        }, null, 8, _hoisted_5),
        _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t("reauth.formText2")), 1),
        (_unref(appleReAuthAllowed) || _unref(googleReAuthAllowed) || _unref(facebookReAuthAllowed))
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("reauth.social_headline")), 1),
              (_unref(store).isSocialLogin)
                ? (_openBlock(), _createBlock(GlobalError, { key: 0 }))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                (_unref(appleReAuthAllowed))
                  ? (_openBlock(), _createBlock(AppleLogin, { key: 0 }))
                  : _createCommentVNode("", true),
                (_unref(googleReAuthAllowed))
                  ? (_openBlock(), _createBlock(GoogleLogin, { key: 1 }))
                  : _createCommentVNode("", true),
                (_unref(facebookReAuthAllowed))
                  ? (_openBlock(), _createBlock(FacebookLogin, { key: 2 }))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.$t("reauth.social_subline")), 1)
            ]))
          : _createCommentVNode("", true),
        (captcha.value.key)
          ? (_openBlock(), _createBlock(_unref(VueRecaptcha), {
              key: 1,
              ref_key: "invisibleReCaptcha",
              ref: invisibleReCaptcha,
              size: "invisible",
              language: _unref(country),
              "load-recaptcha-script": false,
              sitekey: captcha.value.key,
              onVerify: handleCaptchaResponse
            }, null, 8, ["language", "sitekey"]))
          : _createCommentVNode("", true),
        _createVNode(SharedForm, {
          "show-error": false,
          "error-message": "",
          onSubmit: _withModifiers(handleSubmitClick, ["prevent"])
        }, {
          default: _withCtx(() => [
            _createVNode(SharedTextfield, {
              modelValue: password.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((password).value = $event)),
              pattern: _unref(passwordValidator),
              "pattern-error-message": _ctx.$t('validation.password'),
              required: "",
              "required-error-message": _ctx.$t('validation.password'),
              name: "j_password",
              "display-name": _ctx.$t('password-display-name'),
              type: "password",
              autocomplete: "current-password",
              placeholder: _ctx.$t('reauth.password'),
              class: "mb-4",
              "forced-error-message": _unref(store).httpErrorStatusCode === 422 && !_unref(store).isSocialLogin ? ' ' : '',
              "validate-on-change": "",
              onInput: handleOnInput
            }, null, 8, ["modelValue", "pattern", "pattern-error-message", "required-error-message", "display-name", "placeholder", "forced-error-message"]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("a", {
                class: "underline",
                href: passwortForgottenLink(),
                "data-track-element": "PasswordForgotten",
                onClick: sendTracking
              }, _toDisplayString(_ctx.$t("login.forgot_password")), 9, _hoisted_12),
              (_unref(registrationOrigin) === 'APP')
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    href: passwortForgottenLink(),
                    "data-track-element": "AppPassword",
                    onClick: sendTracking
                  }, [
                    _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.$t("reauth.app_user")) + " ", 1),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("reauth.create_password")), 1)
                  ], 8, _hoisted_13))
                : _createCommentVNode("", true)
            ]),
            (!_unref(store).isSocialLogin)
              ? (_openBlock(), _createBlock(GlobalError, {
                  key: 0,
                  class: "mt-2"
                }))
              : _createCommentVNode("", true),
            _createVNode(SharedButton, {
              type: "submit",
              "data-track-element": "OCMButton",
              class: "mt-2 mb-12 w-full",
              "is-loading": isSubmitLoading.value,
              disabled: !(!!captcha.value.key === captcha.value.loaded),
              onClick: sendTracking
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t("reauth.submit_button")), 1)
              ]),
              _: 1
            }, 8, ["is-loading", "disabled"]),
            hasCaptcha
              ? (_openBlock(), _createBlock(CaptchaText, { key: 1 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onSubmit"])
      ])
    ])
  ]))
}
}

})